import { Component, OnInit } from '@angular/core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';

@Component({
  selector: 'app-recommendation-group-report',
  templateUrl: './recommendation-group-report.component.html',
  styleUrls: ['./recommendation-group-report.component.sass']
})
export class RecommendationGroupReportComponent implements OnInit {
  faSearch = faSearch;
  faCalendarAlt = faCalendarAlt;

  constructor() { }

  ngOnInit() {
  }

}
